import axios from "axios";

import { agentPortalChargeBookingFeeApi } from "../../paths";
import {
  IApiConfig,
  NETWORK_CALL_FAILED,
  TransactionStoreId,
} from "@hopper-b2b/types";
import { trackEvent } from "@hopper-b2b/api";

// TODO: add to redmond when types can be generated
interface ChargeAgentBookingFeeRequest {
  transactionStoreId: TransactionStoreId;
  initiator: {
    id: string;
    Initiator: string;
  };
}

type ChargeAgentBookingFeeResponse = any;

export const chargeAgentBookingFee = (
  req: ChargeAgentBookingFeeRequest,
  apiConfig?: IApiConfig
): Promise<ChargeAgentBookingFeeResponse> =>
  new Promise(async (resolve, reject) => {
    try {
      const res = await axios.post(agentPortalChargeBookingFeeApi, req);

      const responseBody = res.data;
      resolve(responseBody);
    } catch (e) {
      trackEvent(
        {
          eventName: NETWORK_CALL_FAILED,
          properties: {
            url: window.location.pathname,
          },
        },
        apiConfig
      );
      reject(e);
    }
  });
